import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import PageContainer from '../../@layout/PageContainer';
import { ModuleProps } from '../../../types';
import HeaderBar from '../HeaderBar';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: `${theme.spacing(3)}px ${theme.spacing(5)}px`
    }
  };
});

const AdminHelp: React.FC<ModuleProps> = props => {
  const classes = useStyles();
  const { t } = useTranslation('AdminHelp');

  return (
    <PageContainer>
      <HeaderBar {...props} />
      <Container className={classes.container}>
        <Typography>{t('Welcome')}</Typography>
      </Container>
    </PageContainer>
  );
};

export default AdminHelp;
